import React, { useEffect, useState, useRef } from 'react';

interface OddsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  odds: string | number;
  selected?: boolean;
}

export const OddsButton: React.FC<OddsButtonProps> = ({ odds, selected, className, children, ...props }) => {
  const [flash, setFlash] = useState<'up' | 'down' | null>(null);
  const prevOddsRef = useRef(odds);

  useEffect(() => {
    // Sadece '-' olmayan gecerli rakamlarda yukselis/dusus olculsun
    if (odds !== '-' && prevOddsRef.current !== '-' && odds !== prevOddsRef.current) {
      if (Number(odds) > Number(prevOddsRef.current)) setFlash('up');
      else if (Number(odds) < Number(prevOddsRef.current)) setFlash('down');
      
      const t = setTimeout(() => setFlash(null), 2400); // 0.8s * 3 = 2.4s parlamasi icin
      
      prevOddsRef.current = odds;
      return () => clearTimeout(t);
    }
  }, [odds]);

  return (
    <button 
      {...props}
      className={`relative overflow-hidden ${className || ''}`}
    >
      <style>{`
        @keyframes oddsBlink {
          0%, 100% { opacity: 1; }
          40% { opacity: 0; }
        }
        .odds-blink {
          animation: oddsBlink 0.8s ease-in-out 3;
        }
      `}</style>

      {/* Artis: Sag Ust Yesil Ucgen */}
      {flash === 'up' && !selected && (
        <div 
          className="absolute top-0 right-0 w-[10px] h-[10px] bg-[#00a650] odds-blink z-10 clip-triangle-top" 
          
        />
      )}
      
      {/* Azalis: Sag Alt Kirmizi Ucgen */}
      {flash === 'down' && !selected && (
        <div 
          className="absolute bottom-0 right-0 w-[10px] h-[10px] bg-[#cc0000] odds-blink z-10 clip-triangle-bottom" 
          
        />
      )}

      {children}
    </button>
  );
};
